'use client'
import { SbBlokData, storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc'
import { FC } from 'react'

import { AssetField } from '@/lib/asset'
import { convertPadding } from '@/lib/stylePanel'

import { PhnxHerobanner } from './Herobanner'
import { HerobannerProps } from './Herobanner'

interface HerobannerBlokProps {
  blok: {
    featured_asset?: AssetField
    featured_video?: any
    title: HerobannerProps['title']
    subtitle: HerobannerProps['subtitle']
    button?: SbBlokData[]
    video_id?: string
    asset?: AssetField
    washOpacity?: number
    layout: HerobannerProps['layout']
    padding?: SbBlokData[]
    background?: SbBlokData[]
    text?: SbBlokData[]
    crop_image?: boolean
    title_size?: number
    subtitle_size?: number
  } & SbBlokData
}

const Herobanner: FC<HerobannerBlokProps> = ({ blok }) => {
  const videoId = blok.video_id ? parseInt(blok.video_id, 10) : undefined
  const convertedPadding = convertPadding(blok.padding as any)
  const backgroundColor =
    blok.background && blok.background[0] && (blok.background[0].colour as string)
  const textColor = blok.text && blok.text[0] && (blok.text[0].colour as string)

  return (
    <div {...storyblokEditable(blok)}>
      <PhnxHerobanner
        featureImage={
          blok.featured_asset && {
            src: blok.featured_asset.filename,
            alt: blok.featured_asset.alt,
            focus: blok.featured_asset.focus,
          }
        }
        title={blok.title}
        subtitle={blok.subtitle}
        asset={
          !videoId && blok.asset
            ? {
                src: blok.asset.filename,
                alt: blok.asset.alt,
                focus: blok.asset.focus,
                wash_opacity: blok.washOpacity,
              }
            : undefined
        }
        featureVideo={
          blok.featured_video &&
          blok.featured_video[0] &&
          blok.featured_video[0]?.id && {
            id: blok.featured_video[0].id,
            type: blok.featured_video[0].type as 'youtube' | 'vimeo',
          }
        }
        video={
          typeof videoId === 'number' ? { id: videoId, wash_opacity: blok.washOpacity } : undefined
        }
        button={
          blok.button && blok.button.length > 0
            ? blok.button.map((nestedBlok: SbBlokData) => (
                <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
              ))
            : undefined
        }
        layout={blok.layout}
        textColor={textColor}
        backgroundColor={backgroundColor}
        padding={convertedPadding}
        cropImage={blok.crop_image}
        titleSize={blok.title_size}
        subtitleSize={blok.subtitle_size}
      />
    </div>
  )
}

export default Herobanner
